import { ApiService } from '../parents/api.service';
import { HttpApiClient } from '../api/http-api-client';

export class UploadsApiService extends ApiService {
  static endpoint = 'uploads';

  /**
   * @param {ApiResponse} response
   * @param {File} file
   * @param {object} config
   * @returns {Promise}
   * @public
   */
  static async uploadFile(response, file, config = {
    headers: {
      'Content-Type': file.type,
    },
  }) {
    // get the location token from the response
    const token = response.getHeaders().location.split('/').pop();

    return HttpApiClient.upload(this.buildUrl(token), file, config);
  }
}
